// Libraries
import { Icon, IconProps } from '@chakra-ui/react';

/**
 * Component that renders the File icon.
 *
 * @component
 * @param {IconProps} props - The IconProps for the FileIcon component.
 * @returns {ReactElement} The FileIcon component.
 */
export const FileIcon = (props: IconProps) => {
  const { color = '#8484A0', ...rest } = props;
  return (
    <Icon viewBox='0 0 18 24' color={color} {...rest}>
      <g clipPath='url(#clip0_2574_15796)'>
        <path
          d='M12 0V6H18L12 0ZM14.625 10.5H3.375C2.95898 10.5 2.625 10.834 2.625 11.25V20.25C2.625 20.666 2.95898 21 3.375 21H14.625C15.041 21 15.375 20.666 15.375 20.25V11.25C15.375 10.8328 15.0422 10.5 14.625 10.5ZM6.375 19.5H4.125V17.25H6.375V19.5ZM6.375 15.75H4.125V13.5H6.375V15.75ZM10.125 19.5H7.875V17.25H10.125V19.5ZM10.125 15.75H7.875V13.5H10.125V15.75ZM13.875 19.5H11.625V17.25H13.875V19.5ZM13.875 15.75H11.625V13.5H13.875V15.75Z'
          fill='currentColor'
        />
        <path
          opacity='0.4'
          d='M12 6V0H2.25C1.00734 0 0 1.00734 0 2.25V21.75C0 22.9922 1.00734 24 2.25 24H15.75C16.9927 24 18 22.9927 18 21.75V6H12ZM15.375 20.25C15.375 20.666 15.041 21 14.625 21H3.375C2.95898 21 2.625 20.666 2.625 20.25V11.25C2.625 10.834 2.95898 10.5 3.375 10.5H14.625C15.041 10.5 15.375 10.834 15.375 11.25V20.25Z'
          fill='currentColor'
        />
      </g>
    </Icon>
  );
};
